// extracted by mini-css-extract-plugin
export default {"galleryRemove":"attachments_galleryRemove__gzfkQ","selectedDelete":"attachments_selectedDelete__k3pHV"};